// extracted by mini-css-extract-plugin
export default {"cls1":"Stats-cls1___ad1e45090a97d04aaa5","cls2":"Stats-cls2___904ddec42773f6577a6 Stats-cls1___ad1e45090a97d04aaa5"};